import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Lock, Sparkles } from "lucide-react";
import { IPhoneFrame, StatusBar } from "../IPhoneFrame";
import { agentConversation } from "../../data/phase2Content";
import { AgentText, AgentOptions, AgentInvite } from "./AgentItems";

const DetailSheet = ({ item, onClose }) => (
  <motion.div initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }} transition={{ type: "spring", stiffness: 280, damping: 32 }} className="absolute inset-x-0 bottom-0 z-30 rounded-t-[32px] border-t border-white/10 bg-[#14151B] p-4 pb-6" data-testid="agent-detail-sheet">
    <div className="mb-3 flex justify-center"><span className="h-1.5 w-12 rounded-full bg-white/25" aria-hidden /></div>
    <img src={item.image} alt="" className="h-28 w-full rounded-[20px] object-cover" />
    <p className="mt-3 text-[17px] font-bold text-white">{item.title}</p>
    <ul className="mt-2 space-y-1">{item.details.map((d) => <li key={d} className="text-[13px] text-white/70">{d}</li>)}</ul>
    <p className="mt-2 text-[11px] text-white/55">Only opt-in attendees are shown · sample demo</p>
    <button type="button" onClick={onClose} data-testid="agent-detail-close" className="mt-4 h-10 w-full rounded-full bg-white/90 text-[13px] font-semibold text-[#14151B]">Close</button>
  </motion.div>
);

export const PersonalAgentPreview = ({ revealed }) => {
  const [detail, setDetail] = useState(null);
  const [joined, setJoined] = useState(false);
  const listRef = useRef(null);
  const items = agentConversation.slice(0, revealed);

  useEffect(() => {
    const l = listRef.current;
    if (l) l.scrollTo({ top: l.scrollHeight, behavior: "smooth" });
  }, [revealed]);

  return (
    <IPhoneFrame testId="personal-ai-phone" screenClassName="agent-screen" data-revealed={revealed}>
        <StatusBar light />
        <div className="absolute inset-x-0 top-[54px] z-10 flex items-center gap-3 border-b border-white/[0.07] px-5 pb-3 pt-2">
          <span className="grid h-10 w-10 place-items-center rounded-full bg-gradient-to-br from-[#7866E8] via-[#7398E7] to-[#80D9EB] text-white"><Sparkles size={17} aria-hidden /></span>
          <div className="flex-1">
            <p className="text-[15px] font-semibold text-white">Your AI</p>
            <p className="flex items-center gap-1 text-[11px] text-white/55"><Lock size={10} aria-hidden /> Private · only you can see this</p>
          </div>
        </div>
        <div ref={listRef} className="absolute inset-x-0 bottom-0 top-[124px] space-y-3 overflow-y-auto px-3.5 pb-6 pt-4" data-testid="agent-messages">
          {items.map((m) => (
            <motion.div key={m.id} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} data-testid={`agent-message-${m.id}`}>
              {(m.type === "user" || m.type === "ai") && <AgentText m={m} />}
              {m.type === "options" && <AgentOptions items={m.items} joined={joined} onExplore={setDetail} onJoin={() => setJoined(true)} />}
              {m.type === "invite" && <AgentInvite m={m} />}
            </motion.div>
          ))}
          <p className="pt-1 text-center text-[10px] text-white/50">Sample content — fictional demo</p>
        </div>
        <AnimatePresence>{detail && <DetailSheet item={detail} onClose={() => setDetail(null)} />}</AnimatePresence>
    </IPhoneFrame>
  );
};
